import { BanknotesIcon, ChartBarIcon, CubeIcon } from '@heroicons/vue/24/outline'

const REPORT_DETAIL_BY_PATH = {
  '/revenue-summary': {
    reportId: 'revenue-summary',
    downloadReportType: 'revenue',
    title: 'Revenue summary',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'revenue' },
    dropdownFilter2: true
  },
  '/payout-summary': {
    reportId: 'payouts-report',
    downloadReportType: 'payouts',
    title: 'Payout summary',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'payouts' }
  },
  '/orders-summary': {
    reportId: 'orders-summary',
    downloadReportType: 'bottle_by_range',
    title: 'Orders report',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    dropdownFilter2: true,
    dropdown2Label: 'Fulfillment methods',
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'orders' },
    chartType: 'stackedBar',
    initialMaxProducts: 5
  },
  '/recurring-membership-fees': {
    reportId: 'recurring-membership-fees-report',
    downloadReportType: 'recurring_membership_fees',
    title: 'Recurring membership fees',
    description: 'Number of orders where a recurring membership fee was charged.',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'recurring_membership_fees' }
  },
  '/meal-plans': {
    reportId: 'meal-plans-report',
    title: 'Meal plans',
    description:
      'Meal plan revenue, meals redeemed, and subscriber movement. Download the spreadsheet for the full subscriber roster and payment ledger.',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'meal_plans' }
  },
  '/discount-code-usage': {
    reportId: 'discount-code-usage',
    downloadReportType: 'discount_code_usage',
    title: 'Discount code usage',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'discount_code_usage' },
    chartType: 'stackedBar',
    dropdownFilter2: true,
    dropdownFilter3: true,
    dropdown3Label: 'All codes',
    initialMaxProducts: 5
  },
  '/referral-code-usage': {
    reportId: 'referral-code-usage',
    downloadReportType: 'referral_code_usage',
    title: 'Referral code usage',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'referral_code_usage' },
    chartType: 'stackedBar',
    dropdownFilter2: true,
    dropdownFilter3: true,
    dropdown3Label: 'All codes',
    initialMaxProducts: 5
  },
  '/customer-growth-by-tier': {
    reportId: 'customer-growth-by-tier',
    downloadReportType: 'customer_growth_by_tier',
    title: 'Orders by membership tier',
    description: 'Unique customers with paid orders per membership tier.',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'customer_growth_by_tier' },
    dropdownFilter2: true
  },
  '/membership-tier-growth': {
    reportId: 'membership-tier-growth',
    downloadReportType: 'membership_tier_growth',
    title: 'Membership tier growth',
    description: "Cumulative active members per membership tier, based on each customer's most recent tier selection.",
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'membership_tier_growth' },
    dropdownFilter2: true
  },
  '/revenue-by-membership-tier': {
    reportId: 'revenue-by-membership-tier',
    downloadReportType: 'revenue_by_membership_tier',
    title: 'Revenue by membership tier',
    description: 'Revenue broken down per membership tier.',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'revenue_by_membership_tier' },
    dropdownFilter2: true
  },
  '/products-sold-breakdown': {
    reportId: 'products-sold-breakdown',
    title: 'Products sold breakdown',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' },
      { label: 'By year', value: 'year' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'products_sold_breakdown' },
    downloadReportType: 'products',
    chartType: 'stackedBar',
    dropdownFilter2: true,
    dropdownFilter3: true,
    initialMaxProducts: 5
  },
  '/upsell-sales': {
    reportId: 'upsell-sales',
    title: 'Upsell sales',
    description: 'Products sold from the upsell screen at checkout, counted on the date the order was paid.',
    dateFilter: true,
    dropdownFilter: true,
    dropdownOptions: [
      { label: 'By day', value: 'day' },
      { label: 'By week', value: 'week' },
      { label: 'By month', value: 'month' }
    ],
    hasSupportingTable: true,
    dataSource: { type: 'data_download', report_type: 'upsell_sales' },
    downloadReportType: 'upsell_sales',
    chartType: 'stackedBar',
    dropdownFilter2: true,
    dropdownFilter3: true,
    initialMaxProducts: 5
  }
}

const REPORT_GROUPS = [
  {
    title: 'Revenue',
    subtitle: 'Track and analyse your revenue.',
    reports: [{ to: '/revenue-summary', icon: ChartBarIcon }]
  },
  {
    title: 'Orders',
    subtitle: 'Understand order activity and fulfilment.',
    reports: [
      { to: '/orders-summary', icon: ChartBarIcon },
      { to: '/recurring-membership-fees', icon: ChartBarIcon },
      { to: '/meal-plans', icon: ChartBarIcon }
    ]
  },
  {
    title: 'Discount & referral codes',
    subtitle: 'Track discount and referral code performance.',
    reports: [
      { to: '/discount-code-usage', icon: ChartBarIcon },
      { to: '/referral-code-usage', icon: ChartBarIcon }
    ]
  },
  {
    title: 'Membership tiers',
    subtitle: 'Membership tier performance, revenue, and customer growth.',
    reports: [
      { to: '/membership-tier-growth', icon: ChartBarIcon },
      { to: '/customer-growth-by-tier', icon: ChartBarIcon },
      { to: '/revenue-by-membership-tier', icon: BanknotesIcon }
    ]
  },
  {
    title: 'Payouts',
    subtitle: 'View payout history and reconciliation.',
    reports: [{ to: '/payout-summary', icon: BanknotesIcon }]
  },
  {
    title: 'Product sales',
    subtitle: 'Sales performance by product.',
    reports: [
      { to: '/products-sold-breakdown', icon: CubeIcon },
      { to: '/upsell-sales', icon: CubeIcon }
    ]
  }
]

export const reportDetailByPath = REPORT_DETAIL_BY_PATH
export const REPORT_PATHS = Object.keys(REPORT_DETAIL_BY_PATH)
export const reportGroupsList = REPORT_GROUPS.map(group => ({
  ...group,
  reports: group.reports.map(report => ({ ...report, name: REPORT_DETAIL_BY_PATH[report.to].title }))
}))
